export default class GA4Helper {
    private dl: any;
    private items: any[];
    private enabled: boolean = false;

    public initialize(dl: any) {
        this.log('ga4: initialize');
        this.dl = dl;
        this.enabled = true;
    }

    public userId(uId: number) {
        if(!this.enabled)
            return;
        this.dl.push({ 'user_id': uId });
        this.log('ga4: user_id = ' + uId)
    }
    public onViewItemList(items: []) {
        if(!this.enabled)
            return;
        this.items = items;
        this.pushEvent({
            event: "view_item_list",
            ecommerce: {
                items: items
            }
        })

        const products = document.getElementsByClassName('product-list-item');
        const t = this;
        for (let i = 0; i < products.length; i++) {
            const a  = products[i] as HTMLLinkElement;
            const index = parseInt(a.dataset.index);
            a.onclick = function() {
                t.onListItemSelected(t.items[index]);
            };
        }
    }

    public onListItemSelected(item: any) {
        if(!this.enabled)
            return;
        this.pushEvent({
            event: "select_item",
            ecommerce: {
                items: [ item ]
            }
        });
    }
    
    public onDeliveryList(selected: any) {
        if(!this.enabled)
            return;
        let items : any[] = [];
        selected.forEach(function (element:any) {
            items.push({
                item_id: element.Name,
                item_name: element.Name,
                currency: element.Currency,
                index: element.id,
                item_category: element.CategoryName,
                item_category2: element.CategoryNameText,
                price: element.Price,
                quantity: 1
            });
        });
        
        this.items = items;
        this.pushEvent({
            event: "view_item_list",
            ecommerce: {
                items: items
            }
        });
    }

    public onDeliveryViewItem(id: number) {
        if(!this.enabled)
            return;
        const t = this;
        this.items.forEach(function (item:any) {
            if(item.index == id){
                t.pushEvent({
                    event: "view_item",
                    ecommerce: {
                        items: [item]
                    }
                });
            }
        });
    }

    public onDeliverySelectItem(id: number) {
        if(!this.enabled)
            return;
        const t = this;
        this.items.forEach(function (item:any) {
            if(item.index == id) {
                t.pushEvent({
                    event: "select_item",
                    ecommerce: {
                        items: [item]
                    }
                });
            }
        });
    }
    
    public onPurchase(ecommerceData: any) {
        if(!this.enabled)
            return;
        this.pushEvent({
            event: "purchase",
            ecommerce: ecommerceData
        });
    }

    public onViewItem(items: []) {
        if(!this.enabled)
            return;
        this.items = items;
        this.pushEvent({
            event: "view_item",
            ecommerce: {
                items: items
            }
        });
    }

    public onBeginCheckout(items: []) {
        if(!this.enabled)
            return;
        this.items = items;
        this.pushEvent({
            event: "begin_checkout",
            ecommerce: {
                items: items
            }
        });
    }

    public onAddPaymentInfo(payment_type: string, currency: string, items: any[]) {
        if(!this.enabled)
            return;
        this.items = items;
        this.pushEvent({
            event: "add_payment_info",
            ecommerce: {
                currency: currency,
                value: items[0].price,
                payment_type: payment_type,
                items: items
            }
        });
    }
    
    private pushEvent(event: any) {
        this.dl.push({ ecommerce: null });
        this.dl.push(event);
        this.log('ga4: on ' + event.event);
    }
    
    private log(message: string) {
        //console.log(message)
    }
    
}